import { Component, ElementRef, Input, Optional } from '@angular/core';
import { FormValidationDirective } from '@Shared/Directives/proprietary/form-validation.directive';

@Component({
    standalone: false,
    selector: 'ep-field-group',
    template: ` <div class="fieldGroupName">{{ displayName }}</div>
    <div class="fieldGroupContent">
      <ng-content *ngIf="!hidden"></ng-content>
    </div>`
})
export class FieldGroupComponent {
    @Input()
    name: string = null;

    get displayName(): string {
        if (this.name) {
            return 'Group ' + this.name.slice(5).toUpperCase(); //strip epfg_ prefix
        }
        return 'Group ?';
    }

    constructor(@Optional() private formValidationDirective: FormValidationDirective, public element: ElementRef) { }

    get hidden() {
        if (this.formValidationDirective) {
            return this.formValidationDirective.hidden(this.name);
        }
        return false;
    }
}
